// src/pages/faq/FaqPage.jsx (або як у тебе структура)
// якщо справді це сторінка FAQ, краще назвати FaqPage замість ContactsPage
import React from "react";
import FaqHero from "../../pages/faq/FaqHero";
import FaqAccordion from "./FaqAccordion";
import Footer from "../Footer";

import Reveal from "../../components/Reveal"; // ⬅️ перевір шлях

export default function FaqPage() {
  return (
    <div className="faq-page">
      <Reveal as="section" variant="fade" duration={0.8} threshold={0.15}>
        <FaqHero />
      </Reveal>

      {/* Акордіон плавно зʼявляється при скролі */}
      <Reveal as="div" variant="fade" duration={0.8} threshold={0.15}>
        <FaqAccordion />
      </Reveal>

      {/* Footer з fade-ефектом */}
      <Reveal as="footer" variant="fade" delay={0.08}>
        <Footer />
      </Reveal>
    </div>
  );
}
